import { createSelector, Selector } from 'reselect';

import { ApplicationType, FeatureFlags, GlobalIdentifiedNotification, Partner } from '@/model/global/types';
import { RootState } from '@/model/types';

export const makeSelectInitialized = (): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.global,
    (state) => state.initialized,
  );

export const makeSelectLocale = (): Selector<RootState, string> =>
  createSelector(
    (state: RootState) => state.global,
    (state) => state.locale,
  );

export const makeSelectApplicationType = (): Selector<RootState, ApplicationType> =>
  createSelector(
    (state: RootState) => state.global,
    (state) => state.application,
  );

export const makeSelectNotifications = (): Selector<RootState, GlobalIdentifiedNotification[]> =>
  createSelector(
    (state: RootState) => state.global,
    (errors) => errors.notifications,
  );

export const makeSelectPartner = (): Selector<RootState, Partner | undefined> =>
  createSelector(
    (state: RootState) => state.global,
    (state) => state.partner,
  );

export const makeSelectIsMobileView = (): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.global.viewState,
    (state) => state.isFrame || state.isMobile,
  );

export const makeSelectIsFrameView = (): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.global.viewState,
    (state) => state.isFrame,
  );

export const makeSelectVHSize = (): Selector<RootState, number | undefined> =>
  createSelector(
    (state: RootState) => state.global.viewState,
    (state) => state.vh,
  );

export const makeSelectLoadingState = (): Selector<RootState, { loading: boolean; messageId?: string }> =>
  createSelector(
    (state: RootState) => state.global.viewState.loading,
    (state: RootState) => state.global.viewState.messageId,
    (loading, messageId) => ({ loading, messageId }),
  );

export const makeSelectFeatureFlag = (flag: FeatureFlags): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.global.toggle?.flags,
    (flags) => !!flags?.[flag],
  );

export default {
  makeSelectInitialized,
  makeSelectApplicationType,
  makeSelectLocale,
  makeSelectNotifications,
  makeSelectIsMobileView,
  makeSelectIsFrameView,
  makeSelectLoadingState,
};
